(function() {
    'use strict';

    a3_cabin_reports.directive('nonEligibleTrainees', nonEligibleTrainees);


    /**
     * @memberof CabinReports
     * @ngdoc directive
     * @name nonEligibleTrainees
     * @restrict E
     * @description
     *   Show trainees that are not eligible for this training session
     * @example
     *   Usage:
     *   <non-eligible-trainees></non-eligible-trainees>
     * @ngInject 
     */
    function nonEligibleTrainees(FlightSessionFactory, $routeParams) {
        function link(scope) {

            scope.categories = setCategories();

            //Collect duty trainees
            var dutyTrainees = [];
            if(scope.groundDuty){
                scope.groundDuty.Trainees.forEach(function(related) {
                    related.CrewMembers.forEach(function(trainee) {
                        dutyTrainees.push(trainee);
                    });
                });
            }   
            else{
                var date = $routeParams.date;
                var dutyNo = Number($routeParams.dutyNo);
                var dutyDay = Number($routeParams.dutyDay);
                var crewRouteCourse = scope.crewRouteDuty.Courses.find(x => x.CourseId == scope.course.Id && new moment(x.Date).isSame(date));
                var dutyTrainees = FlightSessionFactory.getCrewRouteFlightTrainees(dutyNo, dutyDay, crewRouteCourse.TrainingFlightIds)
            }

            if(scope.course && scope.course.CourseTrainees){
                categorizeTrainee(dutyTrainees);
            }

            
            scope.dutyTrainees = dutyTrainees;

            function setCategories() {
                var parallelMessage = "Trainees may have already completed this module";
                var sequentialMessage = "Trainees have either completed this module or are not yet ready to start it";

                return [
                    {
                        title:"InvalidPhase",
                        msg: scope.course.isParallel ? parallelMessage : sequentialMessage,
                        trainees:[],
                        all:false
                    },
                    {
                        title:"Submitted",
                        msg:"Trainees have already been submitted",
                        trainees:[],
                        all:false
                    },
                    {
                        title:"RecurrentPeriod",
                        msg:"Trainees have completed the course earlier",
                        trainees:[],
                        all:false
                    },
                    {
                        title:"InvalidRole",
                        msg: "For this training, flight crew trainees can only be assessed by a flight crew instructor",
                        trainees:[],
                        all:false
                    }
                ];
              
            }
    
            function categorizeTrainee(dutyTrainees){
                var allEligibilityTrainees = scope.course.CourseTrainees.concat(scope.course.NonEligibleTrainees);
                dutyTrainees.forEach(function(dutyTrainee) {
                    var courseTrainee = allEligibilityTrainees.find(x => x.CrewId == dutyTrainee.Id);
                    if(courseTrainee){
                        // if (courseTrainee.ActivePhaseStatus == 'Completed') {
                        //     scope.categories.find(x => x.title=="Completed").trainees.push(dutyTrainee);
                        // }
                        if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc=='AlreadySubmitted') {
                            scope.categories.find(x => x.title =="Submitted").trainees.push(dutyTrainee);
                        }
                        if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc=='InvalidPhase') {
                            scope.categories.find(x => x.title=="InvalidPhase").trainees.push(dutyTrainee);
                        }
                        if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc=='CooldownPending') {
                            scope.categories.find(x => x.title =="RecurrentPeriod").trainees.push(dutyTrainee);
                        }
                        if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc=='InvalidRole') {
                            scope.categories.find(x => x.title =="InvalidRole").trainees.push(dutyTrainee);
                        }
                    }
                }); 

                var allCategory = scope.categories.find(x => x.trainees.length == dutyTrainees.length); //all trainees in same category
                if(allCategory){
                    allCategory.all = true;
                }
            }


           
        }

        return {
            restrict: 'E',
            terminal: true,
            templateUrl: "views/Training/non-eligible-trainees.tpl.html",
            scope: false,
            link: link
        }
    }

})();